import React from 'react';
import { Form, InputNumber, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { UNIT_PRICE_INPUT_PROPS } from '../../utils/money';
import { POLISH_DECIMAL_INPUT_NUMBER_PROPS } from '../../utils/transportCostAllocation';
import { formatUnit } from '../../utils/units';

export default function AveragePurchasePriceFields({ disabled }: { disabled: boolean }) {
  const { t } = useTranslation('products');
  return <>
    <Typography.Paragraph type="secondary">{t('fields.averagePurchaseHelp')}</Typography.Paragraph>
    <Form.Item label={t('fields.averagePurchasePricePLN')} name="averagePurchasePricePLN">
      <InputNumber {...UNIT_PRICE_INPUT_PROPS} {...POLISH_DECIMAL_INPUT_NUMBER_PROPS} min={0} max={99999999.9999} disabled={disabled} style={{ width: '100%' }} />
    </Form.Item>
    <Form.Item label={t('fields.averagePurchasePriceUnit')} name="averagePurchasePriceUnit"
      dependencies={['averagePurchasePricePLN']} rules={[({ getFieldValue }) => ({
        validator(_, unit) {
          return getFieldValue('averagePurchasePricePLN') == null || unit
            ? Promise.resolve() : Promise.reject(new Error(t('fields.averagePurchaseUnitRequired')));
        },
      })]}>
      <Select disabled={disabled} allowClear options={(['pcs', 'm2', 'm3'] as const).map(unit => ({
        value: unit, label: formatUnit(unit, 'pl'),
      }))} />
    </Form.Item>
  </>;
}
